import { useIonToast } from "@ionic/react";
import { useCallback } from "react";

import { alertCircleOutline } from "ionicons/icons";

/**
 * Custom hook for displaying toast notifications.
 *
 * This hook provides a convenient way to display toast messages with consistent styling
 * and behavior across the application. It uses Ionic's toast component with predefined
 * styling and an alert icon.
 *
 * @returns displayToast - Function to display a toast notification
 */
const useToast = () => {
  const [toast] = useIonToast();
  const displayToast = useCallback(
    ({
      message,
      duration = 2500,
      position = "bottom",
      positionAnchor = undefined,
    }: {
      message: string;
      duration?: number;
      position?: "bottom" | "top" | "middle";
      positionAnchor?: string;
    }) => {
      toast({
        message,
        duration,
        position,
        positionAnchor,
        icon: alertCircleOutline,
        color: "dark",
        mode: "ios",
      });
    },
    [toast],
  );

  return displayToast;
};

export default useToast;
